export default function IncompleteProfile({ onComplete }: { onComplete: () => void }) {
  const missingFields = [
    { label: 'Mini Bio', section: 'Profil Detayları' },
    { label: 'Uzmanlık Seçimi', section: 'Profil Detayları' },
    { label: 'Maaş Beklentisi', section: 'Çalışma Tercihleri' },
    { label: 'SGK Tercihi', section: 'Çalışma Tercihleri' },
    { label: 'Görünürlük Modu', section: 'Hesap Ayarları' },
  ];

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6 md:p-10">
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-full bg-soft-gold-50 flex items-center justify-center mx-auto mb-4">
            <i className="ri-alert-line text-soft-gold-600 text-2xl" />
          </div>
          <h1 className="text-xl md:text-2xl font-bold text-deep-navy-500 mb-2">
            Profiliniz henüz tamamlanmadı
          </h1>
          <p className="text-sm text-gray-500 leading-relaxed max-w-sm mx-auto">
            Tam erişim için eksik alanları tamamlamanız gerekir. Platform sizi eşleşmeye dahil edemez.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xs font-semibold text-deep-navy-400 uppercase tracking-wider mb-3">
            Tamamlanması gereken alanlar
          </h3>
          <div className="space-y-2">
            {missingFields.map((field) => (
              <div
                key={field.label}
                className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 bg-off-white"
              >
                <i className="ri-checkbox-blank-circle-line text-gray-300 text-sm" />
                <div className="flex-1">
                  <p className="text-sm font-medium text-deep-navy-500">{field.label}</p>
                  <p className="text-xs text-gray-400">{field.section}</p>
                </div>
                <span className="px-2 py-0.5 bg-red-50 text-red-500 text-[10px] font-semibold rounded-full">
                  Eksik
                </span>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={onComplete}
          className="w-full py-3.5 rounded-full text-sm font-semibold text-white bg-dark-teal-500 hover:bg-dark-teal-600 transition-colors cursor-pointer"
        >
          Profilimi Tamamla
        </button>
      </div>
    </div>
  );
}